import { call, put, takeEvery, all, fork } from "redux-saga/effects";
import { SEND_FEEDBACK } from "./actionType";
import { sendFeedbackSuccess, sendFeedbackError } from "./action";
import { postFeedbackAPI } from "../../helpers/fakebackend_helper";

function* sendFeedback(action) {
  try {
    const response = yield call(postFeedbackAPI, action.payload);
    yield put(sendFeedbackSuccess(response));
  } catch (error) {
    yield put(sendFeedbackError(error));
  }
}

function* watchSendFeedback() {
  yield takeEvery(SEND_FEEDBACK, sendFeedback);
}

export default function* feedbackGenSaga() {
  yield all([fork(watchSendFeedback)]);
}
